import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, RouterLink } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-confirm',
    imports: [RouterLink],
    templateUrl: './confirm.component.html',
    styleUrl: './confirm.component.css',
})
export class ConfirmComponent implements OnInit {
    status: 'success' | 'already' | 'invalid' | 'unknown' = 'unknown';
    // readonly navLogoIconUrl = `${environment.CDN_URL}/public/_app/features/generic/logo/013-envheaven-logo-02@0.25x.png`;
    readonly navLogoIconUrl = `${environment.WEB_SITE_01_CDN_01_FULL_URL}/public/_app/features/generic/logo/013-envheaven-logo-02@0.25x.png`;
    readonly localLogoFallback = 'assets/envheaven-logo.png';

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        const s = this.route.snapshot.queryParamMap.get('status');
        if (s === 'success' || s === 'already' || s === 'invalid')
            this.status = s;
    }

    onLogoError(event: Event): void {
        const img = event.target as HTMLImageElement;
        if (img.src !== this.localLogoFallback)
            img.src = this.localLogoFallback;
    }
}
